import React from "react";
import Cta from "@qlik/qlik/src/components/Cta";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import RichText from "@qlik/qlik/src/components/RichText";
import { renderSanitizedHtmlContent } from "@qlik/qlik/src/lib/util/helpers";
import * as styles from "./styles.module.css";

/**
 * CardBannerCTA component.
 * Renders a section with a title, description, and CTA buttons.
 * @param {Object} data - The data for the component.
 */
const CardBannerCTA = ({ data }) => {
    const { additionalConfiguration, backgroundColor, backgroundImage, customId } = data ?? {};
    const sectionPaddingClassName = getSpacingClassName(additionalConfiguration, "py-25 px-3.75");
    const { sectionColorMapping } = getColorClassName(backgroundColor);
    return (
        <section
            id={customId}
            style={{
                backgroundImage: `url(${
                    backgroundImage?.[0]?.secure_url
                        ? backgroundImage[0].secure_url.replace("/f_auto", "").replace("/q_auto", "")
                        : null
                })`,
            }}
            className={`${sectionPaddingClassName} relative z-1 bg-no-repeat ${
                data.cardItem?.eyebrowText ? "bg-bottom-cta-with-eyebrow" : "bg-bottom-cta"
            }  ${styles.section} ${sectionColorMapping?.bgColor || "bg-blue"}`}
        >
            <div className="container">
                {data.cardItem?.eyebrowText && (
                    <p className="text-white tag-1 text-center uppercase mb-2.5">{data.cardItem?.eyebrowText}</p>
                )}
                {data.cardItem?.title && (
                    <h2
                        className={`${styles.heading} ${sectionColorMapping?.primaryTextColor ||
                            "text-white"} m-auto text-center`}
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(data.cardItem?.title) }}
                    />
                )}
                {data.cardItem?.body && (
                    <RichText data={data.cardItem} className={`text-center mt-3.75 ${styles.eyebrowHeading}`} />
                )}
                <div
                    className={`flex flex-wrap justify-center gap-3.75 md:gap-y-5 ${
                        data.cardItem?.cta === null || data.cardItem?.title === null ? "mt-0" : "mt-10 lg:mt-15.25"
                    } `}
                >
                    {data.cardItem?.cta?.map((button) => (
                        <Cta key={button.id} data={button} className="py-2.5 lg:py-3.75" />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default CardBannerCTA;
